<div [formGroup]="formGroup" class="flex w-full flex-col" *transloco="let t">
  <mat-form-field appearance="outline" class="fuse-mat-dense flex-auto" subscriptSizing="dynamic">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <!-- `pr-2` no texto + margem no swatch: sem o respiro, o hex digitado corria por baixo do quadrado. -->
    <input matInput type="text" class="pr-2" [name]="controlName" [placeholder]="placeholder" [formControlName]="controlName" />

    <!-- `(input)` e não `(change)`: a cor acompanha o arrasto no seletor, não só o soltar. -->
    <input
      class="ml-3 mr-1 size-8 shrink-0 cursor-pointer rounded border"
      type="color"
      matSuffix
      [value]="swatchColor()"
      (input)="applySwatchColor($any($event.target).value)"
    />
  </mat-form-field>
</div>
